<template>
  <transition
    enter-active-class="ease-out duration-300"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="ease-in duration-200"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div v-show="isOpen" class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center z-80">
      <transition
        enter-active-class="ease-out duration-300"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div v-show="isOpen" class="fixed inset-0 transition-opacity backdrop-filter" @click="handleBackgroundClick">
          <div class="absolute inset-0 bg-gray-700/50"></div>
        </div>
      </transition>

      <transition
        enter-active-class="ease-out duration-300"
        enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-from-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          v-show="isOpen"
          class="transform transition-all sm:h-full sm:w-full sm:p-6 fixed sm:static inset-0 overflow-hidden flex flex-col-reverse sm:justify-center sm:items-center pointer-events-none"
        >
          <div :class="[`${overflowAuto ? 'overflow-auto' : ''}`, 'pointer-events-auto w-full p-2 sm:p-0 z-80', `sm:max-w-${size}`]">
            <slot />
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  inheritAttrs: false,
  emits: ["showing", "hiding"],
  props: {
    preventCloseOnBackgroundClick: Boolean,
    size: {
      type: String,
      default: "xl",
    },
    overflowAuto: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    show() {
      this.isOpen = true;
    },
    hide() {
      this.isOpen = false;
    },
    handleBackgroundClick() {
      if (!this.preventCloseOnBackgroundClick) {
        this.isOpen = false;
      }
    },
  },
  watch: {
    isOpen(newVal) {
      this.$emit(newVal ? "showing" : "hiding");
    },
  },
};
</script>
